import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 15px;
	color: #fff;
	> * {
		color: #fff;
		outline: none;
		box-sizing: border-box;
	}
`;

const Error = styled.span`
	line-height: 16px;
	font-size: 14px;
	font-family: "MotoGPText";
	padding-bottom: 4px;
	color: #c80502;
`;

const Title = styled.p`
	font-size: 12px;
	line-height: 14px;
	color: #fff;
	font-family: "MotoGPText";
	padding-bottom: 10px;
`;

interface IProps {
	title?: string;
	error_message?: string;
	as?: any;
}

export const FormGroup: React.FC<IProps> = ({error_message, title, children, ...rest}) => {
	return (
		<Wrapper {...rest}>
			{title && <Title>{title}</Title>}

			{error_message && <Error>{error_message}</Error>}
			{children}
		</Wrapper>
	);
};
